export type OrganizationLogoFetchedPayload = {
	dataUrl: string | null;
};

export type OrganizationLogoFetchedAction = {
	type: 'ORGANIZATION_LOGO_FETCHED';
	payload: OrganizationLogoFetchedPayload;
	organizationId: number;
};

export default (
	payload: OrganizationLogoFetchedPayload,
	organizationId: number,
): OrganizationLogoFetchedAction => ({
	type: 'ORGANIZATION_LOGO_FETCHED',
	payload,
	organizationId,
});
